<template>
  <div>
    <div class="d-flex">
      <page-title :value="$t('features.nursery-web-messaging-inbox')"></page-title>

      <v-spacer></v-spacer>

      <v-btn color="primary" variant="flat" to="/mail/new">
        <v-icon start>mdi-plus</v-icon>
        {{ $t('common.create') }}
      </v-btn>
    </div>

    <v-alert
      class="my-4"
      type="info"
      color="primary"
      variant="outlined"
      density="compact"
      style="font-size: 0.9rem"
    >
      Messages sent here are delivered to the parent app "CCS HOME" chat screen, similar to broadcast messages created in the mobile app "CCS".<br />
      The list below shows both messages sent from this screen and those sent from the mobile app.
    </v-alert>

      <v-tabs v-model="tab" color="primary">
        <v-tab value="delivered">Delivered</v-tab>  
        <v-tab value="inProgress">In Progress</v-tab>
        <v-tab value="inDraft">Drafts</v-tab>
      </v-tabs>

    <v-window v-model="tab">
      <v-window-item value="delivered">
        <v-card variant="flat" elevation="2" class="mt-6 pa-2" color="grey-lighten-5"> 
          <v-container fluid>
            <v-row>
              <v-col cols="3">
                <div class="pb-4">Filter by Date</div>
                <date-picker
                  v-model="startedAtFilterValue"
                  label="Start Date"
                ></date-picker>
              </v-col>
              <v-col cols="3">
                <div class="pb-4"><br /></div>
                <date-picker
                  v-model="endedAtFilterValue"
                  label="End Date"
                ></date-picker>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="4">
                <div class="pb-4"><br /></div>
                <v-text-field
                  v-model="titleFilterValue"
                  label="Search Title"
                  variant="outlined"
                  density="compact"
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <div>Sender</div>
                <v-select
                  v-model="userIdFilterValue"
                  :items="staffOptionsList" 
                  item-title="title"
                  item-value="userId"
                  variant="outlined"
                  hide-details
                  clearable
                  density="compact"
                  color="primary"
                >
                  <template v-slot:selection="{ item }">
                    <span v-if="item.value !== 'all'">
                      {{ item.title }}
                    </span>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <div class="pt-10">
          <mail-table-container
            @click="clickDetail"
            @delete="deleteGroupChat"
            :chats="groupChats"
            :loading="loading"
          ></mail-table-container>

          <v-pagination
            class="pt-4"
            v-model="page"
            @update:modelValue="pageClick" :length="Math.ceil(totalItemsCount / limit)"
          >
          </v-pagination>
        </div>
      </v-window-item>

      <v-window-item value="inProgress">
        <v-card variant="flat" elevation="2" class="mt-6 pa-2" color="grey-lighten-5"> 
          <v-container fluid>
            <v-row>
              <v-col cols="3">
                <div class="pb-4">Filter by Date</div>
                <date-picker
                  v-model="startedAtFilterValue"
                  label="Start Date"
                  color="primary"
                ></date-picker>
              </v-col>
              <v-col cols="3">
                <div class="pb-4"><br /></div>
                <date-picker
                  v-model="endedAtFilterValue"
                  label="End Date"
                  color="primary"
                ></date-picker>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="4">
                <div class="pb-4"><br /></div>
                <v-text-field
                  v-model="titleFilterValue"
                  label="Search Title"
                  variant="outlined"
                  density="compact"
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <div>Sender</div>
                <v-select
                  v-model="userIdFilterValue"
                  :items="staffOptionsList" 
                  item-title="title"
                  item-value="userId"
                  variant="outlined"
                  hide-details
                  clearable
                  density="compact"
                  color="primary"
                >
                  <template v-slot:selection="{ item }">
                    <span v-if="item.value !== 'all'">
                      {{ item.title }}
                    </span>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <div class="pt-10">
          <mail-table-container
            @click="clickDetail"
            @delete="deleteGroupChat"
            :chats="groupChats"
            :loading="loading"
          ></mail-table-container>

          <v-pagination
            class="pt-4"
            v-model="page"
            :length="Math.ceil(totalItemsCount / limit)"
          >
          </v-pagination>
        </div>
      </v-window-item>

      <v-window-item value="inDraft">
        <v-card variant="flat" elevation="2" class="mt-6 pa-2" color="grey-lighten-4">
          <v-container fluid>
            <v-row>
              <v-col cols="3">
                <div class="pb-4">Filter by Date</div>
                <date-picker
                  v-model="startedAtFilterValue"
                  label="Start Date"
                ></date-picker>
              </v-col>
              <v-col cols="3">
                <div class="pb-4"><br /></div>
                <date-picker
                  v-model="endedAtFilterValue"
                  label="End Date"
                ></date-picker>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="4">
                <div class="pb-4"><br /></div>
                <v-text-field
                  v-model="titleFilterValue"
                  label="Search Title"
                  variant="outlined"
                  density="compact"
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <div class="pt-10">
          <mail-table-container
            :loading="loading"
            @click="clickDetail"
            :chats="drafts"
          ></mail-table-container>

          <v-pagination
            class="pt-4"
            v-model="page"
            :length="Math.ceil(totalItemsCount / limit)"
          >
          </v-pagination>
        </div>
      </v-window-item>
    </v-window>

    <chat-detail-dialog
      :isOpen="dialog"
      @is-open="dialog = $event"
      :chat="chatDetail"
      :isDraft="tab == 'inDraft'"
    ></chat-detail-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import DatePicker from "@/components/atoms/DatePicker.vue";
// import StaffPicker from '@/components/atoms/StaffPicker.vue'
import MailTableContainer from "@/containers/MailTableContainer.vue";
import { chatModule } from "@/store/dataModules/chatModule";
import LocalDataService from "@/service/LocalDataService";
import { GroupChatResponse } from "chaild-api/lib";
import ChatDetailDialog from "@/components/molecules/ChatDetailDialog.vue";
import dayjs from "dayjs";
import { NurseryUserResponse } from "chaild-api/src/component/nursery/user/types";
import { nurseryUserModule } from "@/store/dataModules/nurseryUserModule";
import ApiChat from "@/api/ApiChat";

interface DataType {
  tab: "delivered" | "inDraft" | "inProgress";
  dialog: boolean;
  loading: boolean;
  chatDetail: GroupChatResponse | null;
  startedAtFilterValue: string;
  endedAtFilterValue: string;
  titleFilterValue: string;
  userIdFilterValue: number | "all";
  limit: number;
  page: number;
}

export default defineComponent({
  name: "Inbox",

  components: {
    PageTitle,
    DatePicker,
    MailTableContainer,
    ChatDetailDialog,
  },

  async mounted() {
    this.loading = true;
    this.startedAtFilterValue = dayjs().format("YYYY-MM-DD");

    const mailInboxStartedAt = sessionStorage.getItem('mailInboxStartedAt');
    const mailInboxEndedAt = sessionStorage.getItem('mailInboxEndedAt');
    const mailInboxTitle = sessionStorage.getItem('mailInboxTitle');
    const mailInboxUserId = sessionStorage.getItem('mailInboxUserId');
    const mailInboxPage = sessionStorage.getItem('mailInboxPage');

    if (mailInboxStartedAt) this.startedAtFilterValue = mailInboxStartedAt;
    if (mailInboxEndedAt) this.endedAtFilterValue = mailInboxEndedAt;
    if (mailInboxTitle) this.titleFilterValue = mailInboxTitle;
    if (mailInboxUserId) this.userIdFilterValue = Number(mailInboxUserId);

    await this.listGroupChats();
    await this.listStaffs(this.startedAtFilterValue);
    if (mailInboxPage) this.page = Number(mailInboxPage);
    this.loading = false;
  },

  watch: {
    filterValues: {
      handler() {
        if (this.filterValues.startedAt) sessionStorage.setItem('mailInboxStartedAt', String(this.filterValues.startedAt)); else sessionStorage.setItem('mailInboxStartedAt', '');
        if (this.filterValues.endedAt) sessionStorage.setItem('mailInboxEndedAt', String(this.filterValues.endedAt)); else sessionStorage.setItem('mailInboxEndedAt', '');
        if (this.filterValues.title) sessionStorage.setItem('mailInboxTitle', String(this.filterValues.title)); else sessionStorage.setItem('mailInboxTitle', '');
        if (this.filterValues.userId) sessionStorage.setItem('mailInboxUserId', String(this.filterValues.userId)); else sessionStorage.setItem('mailInboxUserId', '');

        this.listStaffs(this.startedAtFilterValue);
        this.listGroupChats();
      },
    },
    tab: {
      handler(val) {
        this.startedAtFilterValue = "";
        this.endedAtFilterValue = "";
        this.titleFilterValue = "";
        this.userIdFilterValue = "all";
        this.listGroupChats();
      },
    },
    page: {
      handler() {
        this.listGroupChats();
      },
    },
  },

  data: (): DataType => {
    return {
      tab: "delivered",
      dialog: false,
      loading: false,
      chatDetail: null,
      startedAtFilterValue: "",
      endedAtFilterValue: "",
      titleFilterValue: "",
      userIdFilterValue: "all",
      limit: 10,
      page: 1,
    };
  },

  computed: {
    groupChats: function (): GroupChatResponse[] {
      return chatModule.groupChats;
    },
    drafts: function (): GroupChatResponse[] {
      return chatModule.drafts;
    },
    filterValues() {
      return {
        startedAt: this.startedAtFilterValue,
        endedAt: this.endedAtFilterValue,
        title: this.titleFilterValue,
        userId: this.userIdFilterValue == "all" ? "" : this.userIdFilterValue,
      };
    },
    totalItemsCount: function (): number {
      return chatModule.totalItemsCount;
    },
    staffs: function (): NurseryUserResponse[] {
      return nurseryUserModule.staffs.filter(s => !s.isHidden);
    },
    // セレクトボックスのクラッシュ防止用配列
    staffOptionsList() {
      if (!this.staffs) return [];
      return this.staffs.map(s => ({
        ...s,
        title: `${s.lastName}${s.firstName}`
      }));
    }
  },

  methods: {
    async pageClick(pageNumber: number) {
      if (pageNumber) sessionStorage.setItem('mailInboxPage', String(pageNumber));
    },
    async listGroupChats() {
      this.loading = true;

      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await chatModule.listGroupChats({
          nurseryId: nurseryId,
          status: this.tab,
          ...this.filterValues,
          skip: (this.page - 1) * this.limit,
          limit: this.limit,
        });
      }

      this.loading = false;
    },
    async listStaffs(date: string) {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await nurseryUserModule.listStaffs({ date: date });
      }
    },
    clickDetail(item: GroupChatResponse) {
      this.chatDetail = item;
      this.dialog = true;
    },
    async deleteGroupChat(item: GroupChatResponse) {
      const answer = confirm("Are you sure you want to delete?");
      if (answer) {
        const response = await ApiChat.deleteGroupChat({
          groupChatIds: String(item.groupChatId),
        }).catch(() => (this.loading = false));
        if (response) {
          alert("Deleted successfully");
          await this.listGroupChats();
        }
        this.loading = false;
      }
    },
  },
});
</script>
<style>
.tabs-container {
    margin-top: 40px;
    margin-bottom: 40px; /* 下のマージンを36pxに設定 */
  }
</style>